import { loadView, withNestedView } from '@/router/routerHelpers';
import { FEATURES } from '@/access/features';

const loadAgentView = withNestedView('agents');

const agentsRoutes = [
  {
    path: '/agents',
    component: loadView('agents/AgentsGate'),
    children: [
      {
        path: '',
        name: 'agents',
        component: loadAgentView('Agents'),
        meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
      },
      {
        path: 'new',
        name: 'agentsNew',
        component: loadAgentView('AgentDetail'),
        props: { isNew: true },
        meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
      },
      {
        path: ':id',
        component: loadAgentView('AgentDetail'),
        props: true,
        meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
        children: [
          { path: '', redirect: 'identity' },
          {
            path: 'identity',
            name: 'agentIdentity',
            component: loadAgentView('tabs/AgentInfoTab'),
            meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
          },
          {
            path: 'instructions',
            name: 'agentInstructions',
            component: loadAgentView('tabs/AgentInstructionsTab'),
            meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
          },
          {
            path: 'tools',
            name: 'agentTools',
            component: loadAgentView('tabs/AgentToolsTab'),
            meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
          },
          {
            path: 'contacts',
            name: 'agentContacts',
            component: loadAgentView('tabs/AgentContactsTab'),
            meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
          },
          {
            path: 'test',
            name: 'agentTest',
            component: loadAgentView('tabs/AgentTestTab'),
            meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
          },
          {
            path: 'logs',
            name: 'agentLogs',
            component: loadAgentView('tabs/AgentLogsTab'),
            meta: { showNav: true, feature: FEATURES.CUSTOM_AGENTS },
          },
          {
            path: 'versions',
            name: 'agentVersions',
            component: loadAgentView('tabs/AgentVersionsTab'),
          },
          {
            path: 'review-release',
            name: 'agentReviewRelease',
            component: loadAgentView('tabs/AgentReviewReleaseTab'),
          },
        ],
      },
    ],
  },
];

export default agentsRoutes;
